import styled from "styled-components";
import { Link } from "react-router-dom";
import { Table, Button } from "semantic-ui-react";

export const SemanticTable = styled(Table)`
  th {
    font-size: 14 !important;
    font-family: sans-serif !important;
  }

  tr {
    font-size: 14;
    font-family: sans-serif;
    text-align: left;
    :hover {
      background: rgba(34, 36, 38, 0.1);
    }
  }

  tfoot {
    a {
      color: #000000 !important;

      i {
        color: #000000 !important;
      }
    }
  }
`;

export const Container = styled.div`
  width: 100vw;
  min-height: 100vh;
  background: #ffffff;
  padding-left:250px;
`;

export const Content = styled.div`
  width: 90%;
  max-width: 1100px;
  margin: 24px auto;
`;

export const Title = styled.h1`
  width: 100%;
  margin: 0px 0px 15px 0px;
  padding: 0px;

  color: #000000;

  font-size: 28px;
  font-family: sans-serif;
  font-weight: 600;

  border-bottom: 1px solid rgba(34, 36, 38, 0.15);

  display: inline-block;
`;

export const Formulario = styled.form`
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 1rem;

  & > button {
    width: fit-content;
    margin-top: 14px;
    background: #eee;
    border: solid 1px #ccc;
    border-radius: 12px;
    padding: 6px 18px;
    font-size: 16px;
    cursor: pointer;
    transition: linear 0.1s;

    :hover {
      transition: linear 0.1s;
      transform: scale(1.05);
    }
  }

  & > label {
    & > span {
      text-align: left;
      margin-top: 24px;
      margin-bottom: 8px;
      display: block;
      font-weight: 400;

      h3 {
        display: inline-block;
        text-decoration: underline;
        margin-bottom: -20px;
      }
    }

    & > select {
      width: 100%;
      padding: 0.5rem;
      font-size: 16px;
      cursor: pointer;
      border: 1px solid rgba(34, 36, 38, 0.15);
      margin-top: 0.25em;
      margin-bottom: 1em;
      border-radius: 4px;
      height: 42px;
      color: rgba(0, 0, 0, 0.75);

      & > option {
        color: rgba(0, 0, 0, 0.75);
      }
    }
  }
`;

export const ContainerInputSearch = styled.div`
  width: 100%;
  height: 50px;

  & i {
    height: 75% !important;
  }
`;

export const Input = styled.input`
  width: 100%;
  height: 42px;
  margin-top: 0.25em;
  margin-bottom: 1em;
  padding: 0.4em 1em;
  outline: 0;
  background: #ffffff;
  color: rgba(0, 0, 0, 0.75);
  font-size: 16px;
  font-weight: 400;
  font-family: sans-serif;
  font-weight: 400;
  border: 1px solid rgba(34, 36, 38, 0.15);
  border-radius: 4px;
  -webkit-appearance: none;
  box-shadow: 0 0 0 0 transparent inset;
  transition: color 0.1s ease, border-color 0.1s ease;
`;

export const CreateButton = styled(Link)`
  width: 100px;
  height: 35px;

  margin-left: 3px;

  color: #000000;
  background: #e0e1e2;

  border-radius: 5px;

  font-family: sans-serif;
  font-size: 16px;
  font-weight: 600;

  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: #cacbcd;
    font-weight: 700;
    color: #000000;
  }
`;

export const DivTutores = styled.div`
  display: flex;
  flex-direction: row;
`;

export const DivButton = styled.div`
  align-items: right;
  justify-content: right;
`;

export const DivTutor = styled.div`
  width: 33% !important;
  padding: 0.5rem;
  border: 1px solid rgba(34, 36, 38, 0.15);
  border-radius: 4px;
`;

export const DivModulo = styled.div`
  width: 100%;
  padding: 0.5rem;
`;
